import { useContextEnsuringProvider } from '@iheartjane/utils';
import type { PropsWithChildren } from 'react';
import { createContext, useMemo, useState } from 'react';

interface ModalsDisplayedContext {
  commsBannerDisplayed: boolean;
  loginModalDisplayed: boolean;
  setCommsBannerDisplayed: (displayed: boolean) => void;
  setLoginModalDisplayed: (displayed: boolean) => void;
}

const ModalsDisplayedContext = createContext<ModalsDisplayedContext | null>(
  null
);
ModalsDisplayedContext.displayName = 'ModalsDisplayed';

//commsBannerDisplayed, loginModalDisplayed
export const ModalsDisplayedProvider = ({ children }: PropsWithChildren) => {
  const [commsBannerDisplayed, setCommsBannerDisplayed] = useState(false);
  const [loginModalDisplayed, setLoginModalDisplayed] = useState(false);
  const context = useMemo(
    () => ({
      commsBannerDisplayed,
      setCommsBannerDisplayed,
      loginModalDisplayed,
      setLoginModalDisplayed,
    }),
    [
      commsBannerDisplayed,
      setCommsBannerDisplayed,
      loginModalDisplayed,
      setLoginModalDisplayed,
    ]
  );
  return (
    <ModalsDisplayedContext.Provider value={context}>
      {children}
    </ModalsDisplayedContext.Provider>
  );
};

export const useModalsDisplayedContext = () =>
  useContextEnsuringProvider(ModalsDisplayedContext);
